export function replaceExclude(str: string): string {
  if (!str || typeof str !== 'string') return str;

  return str.replace(/[`~!@#$%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/gi, '');
}

export function validateForContainNumber(value: string): string {
  const replacedValue: string = value.replace(/[`~!@#$%^&*()_|+=?;:'",<>\{\}\[\]\\\/]/gi, '');
  const numberPattern: RegExp = /-?\d+(\.\d+)?/g;
  const numbers: RegExpMatchArray = replacedValue.match(numberPattern);

  if (!numbers) return '';

  return numbers[0];
}
